import { Routes } from '@angular/router';

import { LayoutPrincipalComponent } from '@shared/components/layout-principal/layout-principal.component';

import { AdminDadosComponent } from './dados/admin-dados.component';

export const ADMIN_DADOS_ROUTES: Routes = [
  {
    path: '',
    component: LayoutPrincipalComponent,
    children: [
      {
        path: '',
        component: AdminDadosComponent,
      },
      {
        path: 'carga',
        loadChildren: () =>
          import('../carga-dados/carga-dados.router').then(
            (m) => m.ADMIN_CARGA_DADOS_ROUTES
          ),
      },
    ],
  },
];
